module.exports = __webpack_public_path__ + "img/ico_checkout_step_1.b5c3190d.svg";